import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils';
import ClickableTooltip from 'app/components/reusable/ClickableTooltip';
import {getImageByBonusesType, getKeyByType} from 'app/components/my_profile/bonuses/bonuses_utils';
import {getPromoNewRewardDisplay} from 'app/utils/promoNewCardReward';
import type {PromoNewRewardInterface} from 'app/interfaces/articles/PromoNewItemInterface';

interface PromoNewCardPrizeProps {
    isPermanent: boolean
    isParticipating?: boolean
    promoLabel?: string
    promoText?: string
    reward?: PromoNewRewardInterface | null
}

const getBonusTooltipTitle = (type: string, birthday: boolean): string => {
    const key = getKeyByType(type, birthday);

    return `${I18n.t(key)} ${I18n.t('bonus').toLowerCase()}`;
};

const PromoNewCardPrize = ({
    isPermanent,
    isParticipating = false,
    promoLabel,
    promoText,
    reward
}: PromoNewCardPrizeProps): React.ReactElement | null => {
    const rewardAmount = getPromoNewRewardDisplay(reward);

    if (isPermanent) {
        const prizeValue = promoText || (isParticipating ? rewardAmount : null);
        const caption = isParticipating ? null : promoLabel;

        if (!prizeValue && !caption) {
            return null;
        }

        return <div className="promo-new-card__prise promo-new-card__prise--mechanic">
            {prizeValue && <span>{prizeValue}</span>}
            {caption && <p className="promo-new-card__prise-caption">{caption}</p>}
        </div>;
    }

    if (!rewardAmount) {
        return null;
    }

    const {type, birthday} = reward ?? {};
    const rewardBirthday = Boolean(birthday);

    return <div className="promo-new-card__prise">
        <span>{rewardAmount}</span>
        {type && <ClickableTooltip
            className="promo-new-card__bonus-tooltip"
            text={
                <div className="promo-new-card__bonus-tooltip-content">
                    <p className="promo-new-card__bonus-tooltip-title">
                        {getBonusTooltipTitle(type, rewardBirthday)}
                    </p>
                    <p className="promo-new-card__bonus-tooltip-desc">
                        {I18n.t('bonuses_page.bonus_tooltip_desc')}
                    </p>
                    <Link
                        to={getLinkPath('/faq/bonus')}
                        className="promo-new-card__bonus-tooltip-link"
                    >
                        {I18n.t('read_more_u')}
                    </Link>
                </div>
            }
        >
            <img
                src={getImageByBonusesType(type, rewardBirthday)}
                alt={getKeyByType(type, rewardBirthday)}
            />
        </ClickableTooltip>}
    </div>;
};

export default PromoNewCardPrize;
